import React, { useState } from 'react';
import { Icon } from '@emorg-prd/standard-react';
import { Button, Table } from '../../common'
import './OrganizationHomeTableRow.css';
import { useNavigate } from 'react-router-dom';
import { L4Tuple } from '../../../models/entities/OrganizationTuple';
import Organization from '../../../models/entities/Organization';

interface Dictionary {
    [Key: string]: boolean;
}

interface OrganizationHomeTableRowProps {
    l4: L4Tuple;
    open: Dictionary;
    setOpen: (open: any) => any;
    selectedOrganization: Organization;
    setSelectedOrganization: any;
    setDecisionModalVisible: any;
    setIsEditting: any;
    setEditingL5: any;
}

const OrganizationsHomeTableRow = ({
    l4,
    open,
    setOpen,
    selectedOrganization,
    setSelectedOrganization,
    setDecisionModalVisible,
    setIsEditting,
    setEditingL5,
}: OrganizationHomeTableRowProps) => {
    const navigate = useNavigate();

    const handleViewDetails = () => {
        navigate(`/organizations/${l4.item1.id}`);
    };

    const handleDisplayModal = (organization: Organization, modal: string, isL5: boolean) => {
        setSelectedOrganization(organization);
        setDecisionModalVisible({ [modal]: true });
        setIsEditting(true);
        setEditingL5(isL5);
    }

    const rows = [];

    // Main L4 row
    rows.push(
        <Table.Row key={l4.item1.id}>
            <Table.Cell key={`${l4.item1.id}-name`}>
                <div 
                    style={{ cursor: l4.item2.length > 0 ? 'pointer' : 'default', display: 'flex', alignItems: 'center' }}
                    onClick={() => l4.item2.length > 0 && setOpen({ ...open, [l4.item1.displayName]: !open[l4.item1.displayName] })}
                >
                    {l4.item2.length > 0 && (
                        open[l4.item1.displayName] ? <Icon name="caret-down" size="em-c-icon--small" /> : <Icon name="caret-right" size="em-c-icon--small" />
                    )}
                    <span style={{ marginLeft: l4.item2.length > 0 ? '8px' : '24px' }}>
                        {l4.item1.shortName ?? l4.item1.displayName}
                    </span>
                </div>
            </Table.Cell>
            <Table.Cell key={`${l4.item1.id}-l5`}>
                {l4.item2.length > 0 ? '' : 'No Organization L5'}
            </Table.Cell>
            <Table.Cell key={`${l4.item1.id}-actions`}>
                <div style={{ display: 'flex', gap: '8px' }}>
                    <Button
                        //style={{ zIndex: 0 }}
                        variant='primary'
                        size="small"
                        isIconOnlyButton
                        onClick={() => handleDisplayModal(l4.item1, 'createOrEditOrg', false)}
                    >
                        <Icon name="pencil" size="em-c-icon--small" />
                    </Button>
                    <Button
                        //style={{ zIndex: 0 }}
                        variant="primary"
                        size="small"
                        isIconOnlyButton
                        onClick={() => handleDisplayModal(l4.item1, 'deleteOrg', false)}
                    >
                        <Icon name="trashcan" size="em-c-icon--small" />
                    </Button>
                </div>
            </Table.Cell>
            <Table.Cell key={`${l4.item1.id}-empty`}>
                
            </Table.Cell>
        </Table.Row>
    );

    // L5 rows (if expanded)
    if (open[l4.item1.displayName] && l4.item2?.length > 0) {
        l4.item2.forEach((l5) => {
            rows.push(
                <Table.Row key={l5.id}>
                    <Table.Cell key={`${l5.id}-empty1`}>
                        
                    </Table.Cell>
                    <Table.Cell key={`${l5.id}-name`}>
                        {l5.shortName ?? l5.displayName}
                    </Table.Cell>
                    <Table.Cell key={`${l5.id}-actions`}>
                        <div style={{ display: 'flex', gap: '8px' }}>
                            <Button
                                //style={{ zIndex: 0 }}
                                variant='primary'
                                size="small"
                                isIconOnlyButton
                                onClick={() => handleDisplayModal(l5, 'createOrEditOrg', false)}
                            >
                                <Icon name="pencil" size="em-c-icon--small" />
                            </Button>
                            <Button
                                //style={{ zIndex: 0 }}
                                variant="primary"
                                size="small"
                                isIconOnlyButton
                                onClick={() => handleDisplayModal(l5, 'deleteOrg', false)}
                            >
                                <Icon name="trashcan" size="em-c-icon--small" />
                        </Button>
                        </div>
                    </Table.Cell>
                    <Table.Cell key={`${l5.id}-empty2`}>
                        
                    </Table.Cell>
                </Table.Row>
            );
        });
    }

    return <>{rows}</>;
};

export default OrganizationsHomeTableRow;
